// src/components/layout/Dashboard/Restaurant/RestaurantDetail.jsx
import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../../../../hooks/usePermissions";
import PermissionGuard from "../../../../components/RBAC/PermissionGuard";
import { serverURL, postData, deleteData } from "../../../../services/Fetchnodeservices";
import { ThemeContext } from "../../../../context/ThemeContext";
import { useNotification } from "../../../../context/NotificationProvider";

// ─────────────────────────────────────────────────────────────────────────────
// ICONS
// ─────────────────────────────────────────────────────────────────────────────
const EditIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>);
const TrashIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" /></svg>);
const BackIcon = () => (<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>);
const ClockIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>);
const LocationIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>);
const PhoneIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.574 2.81.7A2 2 0 0 1 22 16.92z" /></svg>);
const EmailIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="m22 7-10 7L2 7" /></svg>);
const StarIcon = () => (<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>);
const DocumentIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>);
const TagIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>);
const PlusIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>);
const PercentIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 5L5 19M9 6.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0zM20 17.5a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"/></svg>);
const GiftIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>);
const ChevronLeftIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="15 18 9 12 15 6"/></svg>);
const ChevronRightIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>);
const SpinnerIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" style={{ animation: "spin 0.8s linear infinite", transformOrigin: "center" }}/></svg>);
const EyeIcon = ({ visible }) => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    {visible ? (<><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></>) : (<><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></>)}
  </svg>
);
const Edit2Icon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>);
const LockIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>);
const EyeOffIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>);
const ImageIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>);
const IdCardIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"/><circle cx="12" cy="10" r="3"/><path d="M7 15c0-2 3-3 5-3s5 1 5 3"/></svg>);
const BankIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><rect x="2" y="6" width="20" height="12" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/><line x1="16" y1="14" x2="18" y2="14"/></svg>);
const LicenseIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="8,8 16,8"/><polyline points="8,12 14,12"/><polyline points="8,16 12,16"/></svg>);

// ─────────────────────────────────────────────────────────────────────────────
// SUB-COMPONENTS (Theme-Aware)
// ─────────────────────────────────────────────────────────────────────────────

const StatusBadge = ({ status, theme }) => {
  const isActive = status === "Active";
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: "5px", padding: "4px 10px", borderRadius: "16px", fontSize: "11px", fontWeight: 600, background: isActive ? theme.successLight : `${theme.textMuted}1a`, color: isActive ? theme.success : theme.textMuted }}>
      <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: isActive ? theme.success : theme.textMuted }} />
      {status}
    </span>
  );
};

const ReadyBadge = ({ ready, theme }) => {
  const isReady = ready === "Yes";
  return (
    <span style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", fontWeight: 600, background: isReady ? theme.successLight : theme.warningLight, color: isReady ? theme.success : theme.warning }}>{ready}</span>
  );
};

const OnOffBadge = ({ value, theme }) => {
  const isOn = value === "ON";
  return (
    <span style={{ padding: "4px 10px", borderRadius: "16px", fontSize: "11px", fontWeight: 700, background: isOn ? theme.successLight : `${theme.textMuted}1a`, color: isOn ? theme.success : theme.textMuted }}>{value}</span>
  );
};

const RestaurantImage = ({ picName, label, theme, size = "60px" }) => {
  const [imageError, setImageError] = useState(false);
  const getImageUrl = () => {
    if (!picName || picName.trim() === "" || picName === "NULL" || picName === "null") return null;
    let filename = picName;
    if (filename.includes('/')) filename = filename.split('/').pop();
    return `${serverURL}/public/uploadnew/upload/${filename}`;
  };
  const imageUrl = getImageUrl();
  
  if (!imageUrl || imageError) {
    return (
      <div style={{ width: size, height: size, borderRadius: "12px", background: theme.primaryLight, display: "flex", alignItems: "center", justifyContent: "center", border: `1px dashed ${theme.border}` }}>
        <DocumentIcon style={{ color: theme.primary, width: "24px", height: "24px" }} />
      </div>
    );
  }
  return (
    <img src={imageUrl} alt={label} onError={() => setImageError(true)} style={{ width: size, height: size, borderRadius: "12px", objectFit: "cover", border: `1px solid ${theme.border}` }} />
  );
};

const DocumentCard = ({ document, theme }) => (
  <div style={{ background: theme.surfaceAlt, borderRadius: "12px", border: `1px solid ${theme.border}`, padding: "14px", display: "flex", alignItems: "center", gap: "14px", transition: "all 0.2s" }}
    onMouseEnter={(e) => { e.currentTarget.style.borderColor = theme.primary; }}
    onMouseLeave={(e) => { e.currentTarget.style.borderColor = theme.border; }}>
    <RestaurantImage picName={document.image} label={document.label} theme={theme} size="48px" />
    <div style={{ flex: 1 }}>
      <div style={{ fontSize: "11px", color: theme.textMuted, marginBottom: "4px", display: "flex", alignItems: "center", gap: "6px" }}>
        {document.icon} <span>{document.label}</span>
      </div>
      <div style={{ fontSize: "13px", fontWeight: 600, color: theme.textPrimary, marginBottom: "6px" }}>{document.number || "Not Provided"}</div>
      <div style={{ fontSize: "10px", display: "inline-flex", alignItems: "center", gap: "5px", padding: "3px 8px", borderRadius: "12px", background: document.status === "Verified" ? theme.successLight : theme.warningLight, color: document.status === "Verified" ? theme.success : theme.warning }}>
        <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: document.status === "Verified" ? theme.success : theme.warning }} />
        {document.status || "Pending"}
      </div>
    </div>
  </div>
);

const StatCard = ({ value, label, icon, color, theme }) => (
  <div style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: "14px", padding: "16px", display: "flex", alignItems: "center", gap: "14px", transition: "all 0.3s ease" }}
    onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = `0 8px 16px ${color}15`; }}
    onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}>
    <div style={{ width: "44px", height: "44px", borderRadius: "12px", background: `${color}15`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "22px" }}>{icon}</div>
    <div>
      <div style={{ fontSize: "20px", fontWeight: 700, color: theme.textPrimary }}>{value}</div>
      <div style={{ fontSize: "11px", color: theme.textMuted, fontWeight: 500 }}>{label}</div>
    </div>
  </div>
);

const InfoRow = ({ label, value, icon, theme }) => (
  <div style={{ display: "flex", alignItems: "flex-start", gap: "12px", padding: "12px 14px", background: theme.surfaceAlt, borderRadius: "10px", border: `1px solid ${theme.border}`, transition: "all 0.2s" }}
    onMouseEnter={(e) => { e.currentTarget.style.borderColor = theme.primary; }}
    onMouseLeave={(e) => { e.currentTarget.style.borderColor = theme.border; }}>
    <div style={{ color: theme.primary, flexShrink: 0, marginTop: "2px" }}>{icon}</div>
    <div>
      <div style={{ fontSize: "10px", color: theme.textMuted, marginBottom: "2px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>{label}</div>
      <div style={{ fontSize: "13px", fontWeight: 500, color: theme.textPrimary }}>{value || "—"}</div>
    </div>
  </div>
);

const PasswordDisplay = ({ password, theme }) => {
  const [showPassword, setShowPassword] = useState(false);
  if (!password) return <span style={{ color: theme.textMuted, fontSize: "13px" }}>Not set</span>;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px", background: theme.surface, padding: "6px 10px", borderRadius: "8px", border: `1px solid ${theme.border}` }}>
      <span style={{ fontSize: "13px", fontWeight: 500, color: theme.textPrimary, fontFamily: showPassword ? "inherit" : "monospace", letterSpacing: showPassword ? "0" : "2px" }}>
        {showPassword ? password : "••••••••"}
      </span>
      <button onClick={() => setShowPassword(!showPassword)} style={{ background: "none", border: "none", cursor: "pointer", color: theme.textMuted, padding: "2px", display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px", transition: "color 0.2s" }}
        onMouseEnter={(e) => { e.currentTarget.style.color = theme.primary; }}
        onMouseLeave={(e) => { e.currentTarget.style.color = theme.textMuted; }}>
        <EyeIcon visible={showPassword} />
      </button>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// OFFER TABLE ROW COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const OfferTableRow = ({ offer, index, theme, onEdit, onDelete }) => {
  const getOfferColor = (type) => {
    if (type === 'flat') return "#3b82f6";
    if (type === 'percent') return "#10b981";
    if (type === 'bogo') return "#f59e0b";
    if (type === 'combo') return "#8b5cf6";
    if (type === 'discount') return "#3b82f6";
    if (type === 'percentage') return "#10b981";
    if (type === 'buy_get') return "#f59e0b";
    if (type === 'buy_get_x') return "#8b5cf6";
    return "#64748b";
  };

  const getOfferDescription = () => {
    if (offer.offer_type === 'flat') return `₹${offer.offer} OFF`;
    if (offer.offer_type === 'percent') return `${offer.offer}% OFF`;
    if (offer.offer_type === 'bogo') return `Buy ${offer.buy_quantity || 1}, Get ${offer.free_quantity || 1} Free`;
    if (offer.offer_type === 'combo') return `Combo ₹${offer.offer}`;
    if (offer.offer_type === 'discount') return `₹${offer.offer} OFF`;
    if (offer.offer_type === 'percentage') return `${offer.offer}% OFF`;
    if (offer.offer_type === 'buy_get') return `${offer.buy_quantity}+${offer.free_quantity}`;
    if (offer.offer_type === 'buy_get_x') return `${offer.buy_quantity}+Free`;
    return offer.offer_name;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "No expiry";
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
  };

  const isExpired = offer.offer_end && new Date(offer.offer_end) < new Date();

  return (
    <tr style={{
      borderBottom: `1px solid ${theme.border}`,
      transition: "background 0.2s",
      opacity: isExpired ? 0.5 : 1,
    }}
    onMouseEnter={(e) => e.currentTarget.style.background = theme.surfaceAlt}
    onMouseLeave={(e) => e.currentTarget.style.background = "transparent"}
    >
      <td style={{ padding: "6px 10px", fontSize: "11px", color: theme.textMuted, textAlign: "center" }}>
        {index + 1}
      </td>
      <td style={{ padding: "6px 10px", fontSize: "12px", fontWeight: 500, color: theme.textPrimary }}>
        {offer.offer_name || "Unnamed Offer"}
      </td>
      <td style={{ padding: "6px 10px" }}>
        <span style={{
          padding: "2px 8px",
          borderRadius: "12px",
          fontSize: "9px",
          fontWeight: 600,
          background: `${getOfferColor(offer.offer_type)}15`,
          color: getOfferColor(offer.offer_type),
        }}>
          {offer.offer_type || "Unknown"}
        </span>
      </td>
      <td style={{ padding: "6px 10px", fontSize: "13px", fontWeight: 700, color: getOfferColor(offer.offer_type) }}>
        {getOfferDescription()}
      </td>
      <td style={{ padding: "6px 10px", fontSize: "10px", color: theme.textMuted }}>
        {formatDate(offer.offer_start)}
      </td>
      <td style={{ padding: "6px 10px", fontSize: "10px", color: theme.textMuted }}>
        {formatDate(offer.offer_end)}
      </td>
      <td style={{ padding: "6px 10px" }}>
        <span style={{
          padding: "2px 8px",
          borderRadius: "12px",
          fontSize: "9px",
          fontWeight: 600,
          background: Number(offer.status) === 1 ? theme.successLight : `${theme.textMuted}1a`,
          color: Number(offer.status) === 1 ? theme.success : theme.textMuted,
        }}>
          {Number(offer.status) === 1 ? "Active" : "Inactive"}
        </span>
      </td>
      <td style={{ padding: "6px 10px", textAlign: "right" }}>
        <div style={{ display: "flex", gap: "4px", justifyContent: "flex-end" }}>
          <button
            onClick={() => onEdit(offer)}
            style={{
              padding: "2px 8px",
              borderRadius: "4px",
              border: "none",
              background: theme.warningLight,
              color: theme.warning,
              cursor: "pointer",
              fontSize: "9px",
              display: "flex",
              alignItems: "center",
              gap: "2px",
            }}
          >
            <EditIcon style={{ width: "10px", height: "10px" }} /> Edit
          </button>
          <button
            onClick={() => onDelete(offer.id)}
            style={{
              padding: "2px 8px",
              borderRadius: "4px",
              border: "none",
              background: theme.dangerLight,
              color: theme.danger,
              cursor: "pointer",
              fontSize: "9px",
              display: "flex",
              alignItems: "center",
              gap: "2px",
            }}
          >
            <TrashIcon style={{ width: "10px", height: "10px" }} /> Del
          </button>
        </div>
      </td>
    </tr>
  );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────────────────
const RestaurantDetailPage = ({ 
  restaurant, 
  onBack, 
  onEdit, 
  onDelete, 
  onViewSchedule, 
  onViewMenu, 
  isDark,
  onRestaurantUpdated
}) => {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const { theme } = useContext(ThemeContext);
  const { showError } = useNotification();
  
  const [activeTab, setActiveTab] = useState("overview");
  const [allOffers, setAllOffers] = useState([]);
  const [loadingOffers, setLoadingOffers] = useState(false);
  const [offerError, setOfferError] = useState(null);
  const [offerSearch, setOfferSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isDeleting, setIsDeleting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const scrollContainerRef = useRef(null);
  // Add these state variables near other useState declarations
const [selectedOfferIds, setSelectedOfferIds] = useState([]);
const [bulkDeleting, setBulkDeleting] = useState(false);

  // Payment states
  const [paymentData, setPaymentData] = useState([]);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentSummary, setPaymentSummary] = useState({
    total: 0,
    completed: 0,
    pending: 0,
    platformFee: 0,
    available: 0,
    orderValue: 0,
    totalOrders: 0,
    deliveredOrders: 0,
    activeOrders: 0,
  });

  // ─────────────────────────────────────────────────────────────────────────────
  // FETCH PAYMENTS
  // ─────────────────────────────────────────────────────────────────────────────
  // Add these helper functions inside the component (if not already present)
const getOfferColor = (type) => {
  if (type === 'flat' || type === 'discount') return "#3b82f6";
  if (type === 'percent' || type === 'percentage') return "#10b981";
  if (type === 'bogo' || type === 'buy_get') return "#f59e0b";
  if (type === 'combo' || type === 'buy_get_x') return "#8b5cf6";
  return "#64748b";
};

const getOfferDescription = (offer) => {
  if (offer.offer_type === 'flat' || offer.offer_type === 'discount') return `₹${offer.offer} OFF`;
  if (offer.offer_type === 'percent' || offer.offer_type === 'percentage') return `${offer.offer}% OFF`;
  if (offer.offer_type === 'bogo' || offer.offer_type === 'buy_get') return `Buy ${offer.buy_quantity || 1}, Get ${offer.free_quantity || 1} Free`;
  if (offer.offer_type === 'combo') return `Combo ₹${offer.offer}`;
  if (offer.offer_type === 'buy_get_x') return `${offer.buy_quantity}+Free`;
  return offer.offer_name;
};

const formatDate = (dateStr) => {
  if (!dateStr) return "No expiry";
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};



  const fetchPayments = async () => {
    if (!restaurant?.restroId) return;
    try {
      setPaymentLoading(true);
      const response = await postData("restaurant/paymentsbyrestaurant_id", {
        restaurant_id: restaurant.restroId,
      });
      if (response?.status) {
        const summary = response.summary || {};
        setPaymentData(response.orderEarnings || []);
        setPaymentSummary({
          total: Number(summary.totalEarned || 0),
          completed: Number(summary.paidSettlements || 0),
          pending: Number(summary.pendingSettlements || 0),
          platformFee: Number(summary.platformEarned || 0),
          available: Number(summary.availableBalance || 0),
          orderValue: Number(summary.deliveredOrderValue || 0),
          totalOrders: Number(summary.totalOrders || 0),
          deliveredOrders: Number(summary.deliveredOrders || 0),
          activeOrders: Number(summary.activeOrders || 0),
        });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setPaymentLoading(false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // FETCH ALL OFFERS
  // ─────────────────────────────────────────────────────────────────────────────
  const fetchAllOffers = async () => {
    if (!restaurant?.restroId) return;
    setLoadingOffers(true);
    setOfferError(null);
    try {
      const response = await postData("offers/offer", { designation_id: restaurant.restroId });
      let offersData = [];
      if (response && response.status === true && response.data) offersData = response.data;
      else if (Array.isArray(response)) offersData = response;
      else if (response?.data && Array.isArray(response.data)) offersData = response.data;
      setAllOffers(offersData);
    } catch (error) {
      console.error("Error fetching offers:", error);
      setOfferError(error.message || "Failed to fetch offers");
    } finally {
      setLoadingOffers(false);
    }
  };

  useEffect(() => { 
    fetchAllOffers(); 
    fetchPayments();
  }, [restaurant?.restroId]);

  // Filter offers based on search
  const filteredOffers = allOffers.filter(offer => 
    offer.offer_name?.toLowerCase().includes(offerSearch.toLowerCase()) ||
    offer.offer_type?.toLowerCase().includes(offerSearch.toLowerCase())
  );

  // Pagination
  const totalPages = Math.ceil(filteredOffers.length / rowsPerPage);
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedOffers = filteredOffers.slice(startIndex, startIndex + rowsPerPage);

  // ─────────────────────────────────────────────────────────────────────────────
  // SCROLL HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const scrollLeft = () => scrollContainerRef.current?.scrollBy({ left: -260, behavior: 'smooth' });
  const scrollRight = () => scrollContainerRef.current?.scrollBy({ left: 260, behavior: 'smooth' });

  // ─────────────────────────────────────────────────────────────────────────────
  // ✅ FIXED: TAB HANDLERS - WITH PROPER DATA PASSING
  // ─────────────────────────────────────────────────────────────────────────────
  
  const handleMenuTabClick = () => {
    if (!hasPermission('restaurants.menu')) {
      alert("You don't have permission to view menu");
      return;
    }
    
    if (restaurant?.restroId) {
      // ✅ Save to sessionStorage as fallback
      sessionStorage.setItem('selectedRestaurant', JSON.stringify({
        designation_id: restaurant.restroId || restaurant.id,
        restaurantName: restaurant.organisation_name || restaurant.name || 'Restaurant'
      }));
      
      // ✅ Navigate with complete data in state
      navigate("/dashboard/restaurants/menubyresturent", {
        state: {
          designation_id: restaurant.restroId || restaurant.id,
          restaurantName: restaurant.organisation_name || restaurant.name || 'Restaurant',
          restaurantData: restaurant // Send complete restaurant data
        }
      });
    }
  };


  // Add this function inside the component
const handleBulkDeleteOffers = async () => {
  if (selectedOfferIds.length === 0) {
    alert('Please select at least one offer to delete');
    return;
  }
  
  if (!window.confirm(`Are you sure you want to delete ${selectedOfferIds.length} selected offer(s)? This action cannot be undone.`)) {
    return;
  }
  
  setBulkDeleting(true);
  try {
    // Delete offers one by one or use bulk API
    let deletedCount = 0;
    let failedCount = 0;
    
    for (const offerId of selectedOfferIds) {
      try {
        const response = await postData("offers/delete_offer", { id: offerId });
        if (response && response.status === true) {
          deletedCount++;
        } else {
          failedCount++;
        }
      } catch (err) {
        failedCount++;
        console.error(`Failed to delete offer ${offerId}:`, err);
      }
    }
    
    // Show result message
    if (deletedCount > 0 && failedCount === 0) {
      alert(`✅ Successfully deleted ${deletedCount} offer(s)!`);
    } else if (deletedCount > 0 && failedCount > 0) {
      alert(`⚠️ Deleted ${deletedCount} offer(s), but ${failedCount} offer(s) failed to delete.`);
    } else {
      alert(`❌ Failed to delete any offers. Please try again.`);
    }
    
    setSelectedOfferIds([]);
    fetchAllOffers(); // Refresh the list
  } catch (error) {
    alert('Failed to delete offers: ' + error.message);
  } finally {
    setBulkDeleting(false);
  }
};
  const handleOrdersTabClick = () => {
    if (!hasPermission('orders.view')) {
      alert("You don't have permission to view orders");
      return;
    }
    if (restaurant?.restroId) {
      navigate("/dashboard/restaurants/orders", { 
        state: { 
          designation_id: restaurant.restroId, 
          restaurantName: restaurant.organisation_name || restaurant.restaurant_name || restaurant.name || 'Restaurant', 
          filterByRestaurant: true 
        } 
      });
    }
  };

  const handleGoToOffers = () => {
    if (!hasPermission('restaurants.active_offers')) {
      alert("You don't have permission to manage offers");
      return;
    }
    if (restaurant?.restroId) {
      sessionStorage.setItem('selectedRestaurant', JSON.stringify({ 
        designation_id: restaurant.restroId, 
        restaurantName: restaurant.organisation_name || restaurant.restaurant_name || restaurant.name || 'Restaurant' 
      }));
      navigate("/dashboard/restaurants/offers", { 
        state: { 
          designation_id: restaurant.restroId, 
          restaurantId: restaurant.restroId, 
          restaurantName: restaurant.organisation_name || restaurant.restaurant_name || restaurant.name || 'Restaurant' 
        } 
      });
    }
  };

  const handleLocationTabClick = () => {
    if (!hasPermission('restaurants.location')) {
      alert("You don't have permission to view location");
      return;
    }
    if (restaurant?.restroId) {
      navigate("/dashboard/restaurants/location", { 
        state: { 
          restroId: restaurant.restroId, 
          restaurantName: restaurant.organisation_name || restaurant.restaurant_name || restaurant.name || 'Restaurant', 
          address: restaurant.address, 
          latitude: restaurant.latitude, 
          longitude: restaurant.longitude, 
          isDark 
        } 
      });
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // OFFER HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleEditOffer = (offer) => {
    if (!hasPermission('restaurants.active_offers')) {
      alert("You don't have permission to edit offers");
      return;
    }
    if (restaurant?.restroId) {
      sessionStorage.setItem('selectedRestaurant', JSON.stringify({ 
        designation_id: restaurant.restroId, 
        restaurantName: restaurant.organisation_name || restaurant.restaurant_name || restaurant.name || 'Restaurant' 
      }));
      navigate("/dashboard/restaurants/offers", { 
        state: { 
          designation_id: restaurant.restroId, 
          restaurantId: restaurant.restroId, 
          restaurantName: restaurant.organisation_name || restaurant.restaurant_name || restaurant.name || 'Restaurant', 
          editOffer: offer 
        } 
      });
    }
  };

  const handleDeleteOffer = async (offerId) => {
    if (!hasPermission('restaurants.active_offers')) {
      alert("You don't have permission to delete offers");
      return;
    }
    if (!window.confirm('Are you sure you want to delete this offer?')) return;
    try {
      const response = await postData("offers/delete_offer", { id: offerId });
      if (response && response.status === true) {
        alert('Offer deleted successfully!');
        fetchAllOffers();
      } else {
        alert(response?.message || 'Failed to delete offer');
      }
    } catch (error) {
      alert('Failed to delete offer: ' + error.message);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // RESTAURANT EDIT HANDLER
  // ─────────────────────────────────────────────────────────────────────────────
  const handleEditRestaurantClick = () => {
    if (!hasPermission('restaurants.edit')) {
      showError("You don't have permission to edit restaurants");
      return;
    }
    
    navigate("/Dashboard/editrestaurant", { 
      state: { 
        mode: "edit",
        restaurantData: {
          id: restaurant.id || restaurant.restroId,
          old_id: restaurant.old_id || restaurant.id || restaurant.restroId,
          restroId: restaurant.restroId || restaurant.id,
          name: restaurant.name || "",
          organisation_name: restaurant.organisation_name || "",
          org_type: restaurant.org_type || "",
          pre: restaurant.pre || "",
          gender: restaurant.gender || "",
          contact: restaurant.contact || "",
          email: restaurant.email || "",
          password: restaurant.password || "",
          location: restaurant.location || "",
          city: restaurant.city || "",
          state: restaurant.state || "",
          postal: restaurant.postal || "",
          address: restaurant.address || "",
          latitude: restaurant.latitude || "",
          longitude: restaurant.longitude || "",
          owner_name: restaurant.owner_name || "",
          owner_mobile: restaurant.owner_mobile || "",
          other_person_name: restaurant.other_person_name || "",
          other_person_mobile: restaurant.other_person_mobile || "",
          meet_to: restaurant.meet_to || "",
          interestedin: restaurant.interestedin || "",
          bank_name: restaurant.bank_name || "",
          bank_branch: restaurant.bank_branch || "",
          bank_type: restaurant.bank_type || "",
          account_holder: restaurant.account_holder || "",
          account_number: restaurant.account_number || "",
          ifsc: restaurant.ifsc || restaurant.ifsc_code || "",
          bank_mobile: restaurant.bank_mobile || "",
          upi: restaurant.upi || "",
          comission: restaurant.comission || "",
          special_comission: restaurant.special_comission || "",
          min_order: restaurant.min_order || "",
          platform_charge: restaurant.platform_charge || "",
          handling_charge: restaurant.handling_charge || "",
          gst_percentage: restaurant.gst_percentage || "",
          order_receiving_charges: restaurant.order_receiving_charges || "",
          subscription_id: restaurant.subscription_id || "",
          paid: restaurant.paid?.toString() || "",
          wallet: restaurant.wallet || "0",
          myreferal: restaurant.myreferal || "",
          refer_by: restaurant.refer_by || "",
          is_mou: restaurant.is_mou?.toString() || "",
          status: restaurant.status === "Active" ? "1" : (restaurant._raw?.status || "0"),
          hide: restaurant.hide || "0",
          open_status: restaurant.open_status || "0",
          is_ready: restaurant.is_ready || "0",
          shift_start: restaurant.shift_start || restaurant.shiftStart || "",
          shift_end: restaurant.shift_end || restaurant.shiftEnd || "",
          is_auto_schedule: restaurant.is_auto_schedule?.toString() || "0",
          is_schedule_approved: restaurant.is_schedule_approved?.toString() || "0",
          is_verify_personalinfo: restaurant.is_verify_personalinfo?.toString() || "0",
          is_verify_docinfo: restaurant.is_verify_docinfo?.toString() || "0",
          is_verify_bankinfo: restaurant.is_verify_bankinfo?.toString() || "0",
          remarks_personalinfo: restaurant.remarks_personalinfo || "",
          remarks_docinfo: restaurant.remarks_docinfo || "",
          remarks_bankinfo: restaurant.remarks_bankinfo || "",
          is_approved: restaurant.is_approved?.toString() || "0",
          doc_verification: restaurant.doc_verification || null,
          is_menu: restaurant.is_menu?.toString() || "0",
          isKOT: restaurant.isKOT?.toString() || "0",
          isBill: restaurant.isBill?.toString() || "0",
          menu_direction: restaurant.menu_direction || "neutral",
          menu_direction_type: restaurant.menu_direction_type || "percentage",
          menu_direction_value: restaurant.menu_direction_value || "",
          gst_number: restaurant.gst_number || "",
          food_license_number: restaurant.food_license_number || "",
          aadhar_number: restaurant.aadhar_number || "",
          pan_number: restaurant.pan_number || "",
          pic: restaurant.pic || "",
          r_logo: restaurant.r_logo || "",
          h_logo: restaurant.h_logo || "",
          aadhar_front: restaurant.aadhar_front || "",
          aadhar_back: restaurant.aadhar_back || "",
          pan_card: restaurant.pan_card || "",
          gst_pic: restaurant.gst_pic || "",
          food_license_pic: restaurant.food_license_pic || "",
          bank_pass: restaurant.bank_pass || "",
          cancel_cheque: restaurant.cancel_cheque || "",
          current_menu_page1: restaurant.current_menu_page1 || "",
          current_menu_page2: restaurant.current_menu_page2 || "",
          current_menu_page3: restaurant.current_menu_page3 || "",
          current_menu_page4: restaurant.current_menu_page4 || "",
          current_menu_page5: restaurant.current_menu_page5 || "",
          current_menu_page6: restaurant.current_menu_page6 || "",
          current_menu_page7: restaurant.current_menu_page7 || "",
          current_menu_page8: restaurant.current_menu_page8 || "",
          current_menu_page9: restaurant.current_menu_page9 || "",
          details: restaurant.details || "",
          subject: restaurant.subject || "",
          created_by_id: restaurant.created_by_id || "1",
        }
      }
    });
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // RESTAURANT DELETE HANDLER
  // ─────────────────────────────────────────────────────────────────────────────
  const handleDeleteRestaurant = async () => {
    if (!hasPermission('restaurants.delete')) {
      alert("You don't have permission to delete restaurants");
      return;
    }

    // The listing owns the single confirmation modal and performs the API call.
    // Do not show a second browser confirmation here, otherwise the delete flow
    // looks stuck before any request is sent.
    if (onDelete) {
      onDelete(restaurant);
      return;
    }

    if (!window.confirm(`Are you sure you want to delete "${restaurant.name || 'this restaurant'}"? This action cannot be undone.`)) {
      return;
    }

    setIsDeleting(true);
    try {
      const restaurantId = restaurant.restroId || restaurant.id;
      const response = await deleteData(`restaurant/Restrunts/${restaurantId}`);
      
      if (response?.status === true || response?.success === true) {
        alert(response.message || 'Restaurant deleted successfully!');
        if (onBack) {
          onBack();
        } else {
          navigate('/dashboard/restaurants');
        }
      } else {
        alert(response?.message || 'Failed to delete restaurant');
      }
    } catch (error) {
      alert('Failed to delete restaurant: ' + error.message);
    } finally {
      setIsDeleting(false);
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // SCHEDULE HANDLER
  // ─────────────────────────────────────────────────────────────────────────────
  const handleViewSchedule = () => {
    if (!hasPermission('restaurants.timings')) {
      alert("You don't have permission to view timings");
      return;
    }
    if (onViewSchedule) {
      onViewSchedule();
    } else {
      navigate('/dashboard/restaurants/timings', { 
        state: { 
          restaurantId: restaurant.restroId,
          restaurantName: restaurant.organisation_name || restaurant.restaurant_name || restaurant.name || 'Restaurant',
          shiftStart: restaurant.shiftStart,
          shiftEnd: restaurant.shiftEnd
        } 
      });
    }
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // DOCUMENTS
  // ─────────────────────────────────────────────────────────────────────────────
  const documents = [
    { label: "GST Certificate", icon: <DocumentIcon />, number: restaurant.gst_number || "Not Available", image: restaurant.gst_pic, status: restaurant.gst_number && restaurant.gst_number !== "NULL" ? "Verified" : "Pending" },
    { label: "Food License", icon: <LicenseIcon />, number: restaurant.food_license_number || "Not Available", image: restaurant.food_license_pic, status: restaurant.food_license_number && restaurant.food_license_number !== "NULL" ? "Verified" : "Pending" },
    { label: "PAN Card", icon: <IdCardIcon />, number: restaurant.pan_card || "Not Available", image: restaurant.pan_card, status: restaurant.pan_card && restaurant.pan_card !== "NULL" ? "Verified" : "Pending" },
    { label: "Bank Details", icon: <BankIcon />, number: `${restaurant.bank_name || "Bank"} - ${restaurant.account_number || "Account"}`, image: restaurant.cancel_cheque, status: restaurant.is_verify_bankinfo === "1" ? "Verified" : "Pending" },
    { label: "Restaurant Logo", icon: <ImageIcon />, number: restaurant.organisation_name || "Restaurant Name", image: restaurant.pic, status: restaurant.pic && restaurant.pic !== "NULL" ? "Verified" : "Pending" }
  ].filter(doc => doc.image && doc.image !== "NULL" && doc.image !== "null" && doc.image.trim() !== "");

  // ─────────────────────────────────────────────────────────────────────────────
  // RENDER - Loading State
  // ─────────────────────────────────────────────────────────────────────────────
  if (!restaurant) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '400px', color: theme.textMuted }}>
        <div style={{ textAlign: 'center' }}>
          <SpinnerIcon style={{ width: '40px', height: '40px', color: theme.primary }} />
          <p style={{ marginTop: '16px', fontSize: '14px' }}>Loading restaurant details...</p>
        </div>
      </div>
    );
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // TABS CONFIGURATION WITH PERMISSIONS
  // ─────────────────────────────────────────────────────────────────────────────
  const tabs = [
    { id: "overview", label: "Overview", icon: "🏠", permission: "restaurants.overview" },
    { id: "menu", label: "Menu", icon: "🍽️", permission: "restaurants.menu", onClick: handleMenuTabClick },
    { id: "orders", label: "Orders", icon: "📦", permission: "restaurants.orders", onClick: handleOrdersTabClick },
    { id: "timings", label: "Timings", icon: "⏰", permission: "restaurants.timings" },
    { id: "payments", label: "Payments", icon: "💰", permission: "restaurants.payments" },
    { id: "reviews", label: "Reviews", icon: "⭐", permission: "restaurants.reviews" },
    { id: "location", label: "Location", icon: "📍", permission: "restaurants.location", onClick: handleLocationTabClick },
    { id: "documents", label: "Documents", icon: "📄", permission: "restaurants.documents" },
    { id: "offers", label: "Offers", icon: "🏷️", permission: "restaurants.active_offers" },
  ];

  const visibleTabs = tabs.filter(tab => hasPermission(tab.permission));

  // ─────────────────────────────────────────────────────────────────────────────
  // MAIN RENDER
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div style={{ 
      minHeight: "100vh", 
      background: theme.background, 
      fontFamily: "'Inter', -apple-system, sans-serif", 
      transition: "background 0.3s ease" 
    }}>
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } } 
        .no-scrollbar::-webkit-scrollbar { display: none; } 
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
        .offer-table-container {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .offer-table-container::-webkit-scrollbar {
          height: 4px;
        }
        .offer-table-container::-webkit-scrollbar-track {
          background: ${theme.border};
          border-radius: 10px;
        }
        .offer-table-container::-webkit-scrollbar-thumb {
          background: ${theme.primary};
          border-radius: 10px;
        }
        .offer-table {
          min-width: 600px;
          width: 100%;
          border-collapse: collapse;
        }
        .offer-table th {
          position: sticky;
          top: 0;
          background: ${theme.surface};
          z-index: 1;
        }
      `}</style>
      
      {/* ─── STICKY HEADER ─── */}
      <div style={{ 
        position: "sticky", 
        top: 0, 
        zIndex: 50, 
        background: theme.surface, 
        borderBottom: `1px solid ${theme.border}`, 
        padding: "14px 24px", 
        backdropFilter: "blur(8px)" 
      }}>
        <div style={{ 
          maxWidth: "1200px", 
          margin: "0 auto", 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center" 
        }}>
          <button 
            onClick={onBack} 
            style={{ 
              display: "flex", 
              alignItems: "center", 
              gap: "8px", 
              background: "none", 
              border: "none", 
              color: theme.primary, 
              cursor: "pointer", 
              fontSize: "13px", 
              fontWeight: 600, 
              transition: "opacity 0.2s" 
            }}
            onMouseEnter={(e) => { e.currentTarget.style.opacity = "0.8"; }} 
            onMouseLeave={(e) => { e.currentTarget.style.opacity = "1"; }}
          >
            <BackIcon /> Back to List
          </button>
          
          <div style={{ display: "flex", gap: "10px" }}>
            <PermissionGuard permission="restaurants.edit" fallback={null}>
              <button 
                onClick={handleEditRestaurantClick}
                style={{ 
                  padding: "8px 16px", 
                  borderRadius: "8px", 
                  border: "none", 
                  background: theme.primary, 
                  color: "#fff", 
                  cursor: "pointer", 
                  display: "flex", 
                  alignItems: "center", 
                  gap: "6px", 
                  fontSize: "12px", 
                  fontWeight: 600, 
                  transition: "all 0.2s" 
                }}
                onMouseEnter={(e) => { 
                  e.currentTarget.style.transform = "translateY(-1px)"; 
                  e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`; 
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.transform = "translateY(0)"; 
                  e.currentTarget.style.boxShadow = "none"; 
                }}
              >
                <EditIcon /> Edit
              </button>
            </PermissionGuard>
            
            <PermissionGuard permission="restaurants.delete" fallback={null}>
              <button 
                onClick={handleDeleteRestaurant}
                disabled={isDeleting}
                style={{ 
                  padding: "8px 16px", 
                  borderRadius: "8px", 
                  border: `1px solid ${theme.danger}40`, 
                  background: isDeleting ? theme.textMuted : theme.dangerLight, 
                  color: isDeleting ? theme.textMuted : theme.danger, 
                  cursor: isDeleting ? "not-allowed" : "pointer", 
                  display: "flex", 
                  alignItems: "center", 
                  gap: "6px", 
                  fontSize: "12px", 
                  fontWeight: 600, 
                  transition: "all 0.2s", 
                  opacity: isDeleting ? 0.6 : 1
                }}
                onMouseEnter={(e) => { 
                  if (!isDeleting) {
                    e.currentTarget.style.background = theme.danger; 
                    e.currentTarget.style.color = "#fff"; 
                  }
                }}
                onMouseLeave={(e) => { 
                  if (!isDeleting) {
                    e.currentTarget.style.background = theme.dangerLight; 
                    e.currentTarget.style.color = theme.danger; 
                  }
                }}
              >
                {isDeleting ? <SpinnerIcon /> : <TrashIcon />} 
                {isDeleting ? 'Deleting...' : 'Delete'}
              </button>
            </PermissionGuard>
          </div>
        </div>
      </div>

      {/* ─── MAIN CONTENT ─── */}
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "24px" }}>
        
        {/* ─── HERO HEADER CARD ─── */}
        <div style={{ 
          background: theme.surface, 
          borderRadius: "16px", 
          border: `1px solid ${theme.border}`, 
          padding: "24px", 
          marginBottom: "24px", 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "flex-start", 
          flexWrap: "wrap", 
          gap: "20px" 
        }}>
          <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
            <RestaurantImage 
              picName={restaurant.pic || restaurant.restropic} 
              label={restaurant.name} 
              theme={theme} 
              size="72px" 
            />
            <div>
              <h1 style={{ 
                fontSize: "26px", 
                fontWeight: 700, 
                color: theme.textPrimary, 
                marginBottom: "6px", 
                letterSpacing: "-0.5px" 
              }}>
                {restaurant.organisation_name || restaurant.name || "Unnamed Restaurant"}
              </h1>
              <p style={{ 
                fontSize: "12px", 
                color: theme.textMuted, 
                marginBottom: "12px", 
                fontFamily: "monospace" 
              }}>
                ID: {restaurant.restroId || restaurant.id || "N/A"}
              </p>
              <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                <StatusBadge status={restaurant.status || "Inactive"} theme={theme} />
                <ReadyBadge ready={restaurant.ready || "No"} theme={theme} />
                <OnOffBadge value={restaurant.onOff || "OFF"} theme={theme} />
              </div>
            </div>
          </div>
          
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "8px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              {[...Array(5)].map((_, i) => (
                <StarIcon key={i} style={{ 
                  color: i < Math.floor(restaurant.rating || 0) ? "#fbbf24" : theme.border, 
                  width: "16px", 
                  height: "16px", 
                  transition: "color 0.3s ease" 
                }} />
              ))}
              <span style={{ 
                marginLeft: "8px", 
                fontSize: "13px", 
                color: theme.textPrimary, 
                fontWeight: 600 
              }}>
                {restaurant.rating || 0}
              </span>
              <span style={{ fontSize: "12px", color: theme.textMuted }}>
                ({restaurant.totalRatings || 0} reviews)
              </span>
            </div>
          </div>
        </div>

        {/* ─── MODERN TABS ─── */}
        <div style={{ 
          display: "flex", 
          gap: "8px", 
          borderBottom: `1px solid ${theme.border}`, 
          marginBottom: "24px", 
          overflowX: "auto", 
          paddingBottom: "2px" 
        }} className="no-scrollbar">
          {visibleTabs.map(tab => {
            const isActive = activeTab === tab.id && !tab.onClick;
            return (
              <button 
                key={tab.id} 
                onClick={() => { 
                  if (tab.onClick) {
                    tab.onClick(); 
                  } else {
                    setActiveTab(tab.id); 
                  }
                }} 
                style={{ 
                  display: "flex", 
                  alignItems: "center", 
                  gap: "6px", 
                  padding: "10px 18px", 
                  background: isActive ? theme.primaryLight : "transparent", 
                  border: "none", 
                  borderBottom: isActive ? `3px solid ${theme.primary}` : "3px solid transparent", 
                  borderRadius: "8px 8px 0 0", 
                  cursor: "pointer", 
                  color: isActive ? theme.primary : theme.textMuted, 
                  fontWeight: isActive ? 600 : 500, 
                  fontSize: "13px", 
                  transition: "all 0.2s", 
                  whiteSpace: "nowrap" 
                }}
                onMouseEnter={(e) => { 
                  if (!isActive) { 
                    e.currentTarget.style.color = theme.textPrimary; 
                    e.currentTarget.style.background = theme.surfaceAlt; 
                  } 
                }}
                onMouseLeave={(e) => { 
                  if (!isActive) { 
                    e.currentTarget.style.color = theme.textMuted; 
                    e.currentTarget.style.background = "transparent"; 
                  } 
                }}
              >
                <span>{tab.icon}</span>
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>

        {/* ─── OVERVIEW TAB CONTENT ─── */}
        {activeTab === "overview" && (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(12, 1fr)", gap: "24px" }}>
            
            {/* Left Column - Spans 8 columns */}
            <div style={{ gridColumn: "span 8" }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "16px", marginBottom: "20px" }}>
                {/* Contact Information */}
                <div style={{ 
                  background: theme.surface, 
                  borderRadius: "14px", 
                  border: `1px solid ${theme.border}`, 
                  overflow: "hidden" 
                }}>
                  <div style={{ 
                    padding: "14px 18px", 
                    borderBottom: `1px solid ${theme.border}`, 
                    background: theme.surfaceAlt 
                  }}>
                    <h3 style={{ 
                      fontSize: "14px", 
                      fontWeight: 600, 
                      color: theme.textPrimary, 
                      margin: 0, 
                      display: "flex", 
                      alignItems: "center", 
                      gap: "8px" 
                    }}>
                      📞 Contact Information
                    </h3>
                  </div>
                  <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
                    <InfoRow label="Phone" value={restaurant.contact || "Not specified"} icon={<PhoneIcon />} theme={theme} />
                    <InfoRow label="Email" value={restaurant.email || "Not specified"} icon={<EmailIcon />} theme={theme} />
                    <div style={{ 
                      display: "flex", 
                      alignItems: "flex-start", 
                      gap: "12px", 
                      padding: "12px 14px", 
                      background: theme.surfaceAlt, 
                      borderRadius: "10px", 
                      border: `1px solid ${theme.border}`, 
                      transition: "all 0.2s" 
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.borderColor = theme.primary; }}
                    onMouseLeave={(e) => { e.currentTarget.style.borderColor = theme.border; }}>
                      <div style={{ color: theme.primary, flexShrink: 0, marginTop: "2px" }}><LockIcon /></div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: "10px", color: theme.textMuted, marginBottom: "2px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px" }}>Password</div>
                        <div style={{ fontSize: "13px", fontWeight: 500, color: theme.textPrimary, display: "flex", alignItems: "center", gap: "8px" }}>
                          <span>
                            {showPassword
                              ? (restaurant.password || "Not set")
                              : (restaurant.password ? "•".repeat(restaurant.password.length) : "Not set")
                            }
                          </span>
                          <button
                            onClick={() => setShowPassword(!showPassword)}
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              color: theme.textMuted,
                              padding: 0,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {showPassword ? <EyeOffIcon /> : <EyeIcon visible={false} />}
                          </button>
                        </div>
                      </div>
                    </div>
                    <InfoRow label="Location" value={restaurant.address || "Not specified"} icon={<LocationIcon />} theme={theme} />
                  </div>
                </div>

                {/* Business Hours */}
                <div style={{ 
                  background: theme.surface, 
                  borderRadius: "14px", 
                  border: `1px solid ${theme.border}`, 
                  overflow: "hidden" 
                }}>
                  <div style={{ 
                    padding: "14px 18px", 
                    borderBottom: `1px solid ${theme.border}`, 
                    background: theme.surfaceAlt 
                  }}>
                    <h3 style={{ 
                      fontSize: "14px", 
                      fontWeight: 600, 
                      color: theme.textPrimary, 
                      margin: 0, 
                      display: "flex", 
                      alignItems: "center", 
                      gap: "8px" 
                    }}>
                      ⏰ Business Hours
                    </h3>
                  </div>
                  <div style={{ padding: "16px", display: "flex", flexDirection: "column", gap: "10px" }}>
                    <InfoRow label="Opening Time" value={restaurant.shiftStart || "10:00 AM"} icon={<ClockIcon />} theme={theme} />
                    <InfoRow label="Closing Time" value={restaurant.shiftEnd || "11:00 PM"} icon={<ClockIcon />} theme={theme} />
                    <PermissionGuard permission="restaurants.timings" fallback={null}>
                      <button 
                        onClick={handleViewSchedule} 
                        style={{ 
                          marginTop: "6px", 
                          padding: "10px", 
                          borderRadius: "10px", 
                          border: `1px solid ${theme.primary}40`, 
                          background: theme.primaryLight, 
                          color: theme.primary, 
                          cursor: "pointer", 
                          fontSize: "12px", 
                          fontWeight: 600, 
                          display: "flex", 
                          alignItems: "center", 
                          justifyContent: "center", 
                          gap: "6px", 
                          transition: "all 0.2s" 
                        }}
                        onMouseEnter={(e) => { 
                          e.currentTarget.style.background = theme.primary; 
                          e.currentTarget.style.color = "#fff"; 
                        }}
                        onMouseLeave={(e) => { 
                          e.currentTarget.style.background = theme.primaryLight; 
                          e.currentTarget.style.color = theme.primary; 
                        }}
                      >
                        <ClockIcon /> Edit Timings
                      </button>
                    </PermissionGuard>
                  </div>
                </div>
              </div>

              {/* About Restaurant */}
              <div style={{ 
                background: theme.surface, 
                borderRadius: "14px", 
                border: `1px solid ${theme.border}`, 
                padding: "20px" 
              }}>
                <h3 style={{ 
                  fontSize: "14px", 
                  fontWeight: 600, 
                  color: theme.textPrimary, 
                  marginBottom: "12px", 
                  display: "flex", 
                  alignItems: "center", 
                  gap: "8px" 
                }}>
                  📝 About Restaurant
                </h3>
                <p style={{ 
                  fontSize: "13px", 
                  lineHeight: "1.6", 
                  color: theme.textSecondary, 
                  marginBottom: "16px" 
                }}>
                  {restaurant.description || "No description available for this restaurant."}
                </p>
                <div style={{ 
                  display: "inline-flex", 
                  alignItems: "center", 
                  gap: "8px", 
                  padding: "6px 14px", 
                  background: theme.surfaceAlt, 
                  borderRadius: "20px", 
                  border: `1px solid ${theme.border}` 
                }}>
                  <span style={{ fontSize: "11px", color: theme.textMuted, fontWeight: 600 }}>Cuisine:</span>
                  <span style={{ fontSize: "12px", fontWeight: 600, color: theme.textPrimary }}>
                    {restaurant.cuisine || "Multi-cuisine"}
                  </span>
                </div>
              </div>
            </div>

            {/* Right Column - Spans 4 columns */}
            <div style={{ gridColumn: "span 4", display: "flex", flexDirection: "column", gap: "20px" }}>
              {/* Quick Stats */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: "12px" }}>
                <StatCard 
                  value={`⭐ ${restaurant.rating || 0}`} 
                  label="Average Rating" 
                  icon="⭐" 
                  color="#fbbf24" 
                  theme={theme} 
                />
                <StatCard 
                  value={`₹${paymentSummary.total.toLocaleString()}`} 
                  label="Restaurant Earnings" 
                  icon="💰" 
                  color={theme.success} 
                  theme={theme} 
                />
                <StatCard 
                  value={paymentSummary.activeOrders} 
                  label="Pending Orders" 
                  icon="📦" 
                  color={theme.warning} 
                  theme={theme} 
                />
                <StatCard 
                  value="0" 
                  label="Menu Items" 
                  icon="🍽️" 
                  color={theme.primary} 
                  theme={theme} 
                />
              </div>

              {/* Active Offers - Compact View */}
              <PermissionGuard permission="restaurants.active_offers" fallback={null}>
                <div style={{ 
                  background: theme.surface, 
                  borderRadius: "14px", 
                  border: `1px solid ${theme.border}`, 
                  overflow: "hidden" 
                }}>
                  <div style={{ 
                    padding: "14px 18px", 
                    borderBottom: `1px solid ${theme.border}`, 
                    background: theme.surfaceAlt, 
                    display: "flex", 
                    justifyContent: "space-between", 
                    alignItems: "center" 
                  }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <TagIcon style={{ width: "16px", height: "16px", color: theme.primary }} />
                      <div>
                        <h3 style={{ fontSize: "13px", fontWeight: 600, color: theme.textPrimary, margin: 0 }}>
                          Active Offers
                        </h3>
                        <p style={{ fontSize: "10px", color: theme.textMuted, margin: 0 }}>
                          {allOffers.filter(o => Number(o.status) === 1).length} promotion{allOffers.filter(o => Number(o.status) === 1).length !== 1 ? 's' : ''}
                        </p>
                      </div>
                    </div>
                    <PermissionGuard permission="restaurants.active_offers" fallback={null}>
                      <button 
                        onClick={handleGoToOffers} 
                        style={{ 
                          padding: "6px 12px", 
                          borderRadius: "8px", 
                          border: "none", 
                          background: theme.primary, 
                          color: "#fff", 
                          cursor: "pointer", 
                          fontSize: "11px", 
                          fontWeight: 600, 
                          display: "flex", 
                          alignItems: "center", 
                          gap: "4px", 
                          transition: "all 0.2s" 
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-1px)"; }}
                        onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}
                      >
                        <PlusIcon style={{ width: "12px", height: "12px" }} /> Create
                      </button>
                    </PermissionGuard>
                  </div>
                  <div style={{ padding: "16px", maxHeight: "300px", overflowY: "auto" }}>
                    {loadingOffers ? (
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
                        <SpinnerIcon /> 
                        <span style={{ marginLeft: "8px", fontSize: "12px", color: theme.textMuted }}>
                          Loading...
                        </span>
                      </div>
                    ) : offerError ? (
                      <div style={{ textAlign: "center", padding: "16px" }}>
                        <p style={{ fontSize: "11px", color: theme.danger, marginBottom: "8px" }}>
                          {offerError}
                        </p>
                        <button 
                          onClick={fetchAllOffers} 
                          style={{ 
                            padding: "6px 12px", 
                            borderRadius: "6px", 
                            border: "none", 
                            background: theme.dangerLight, 
                            color: theme.danger, 
                            cursor: "pointer", 
                            fontSize: "11px", 
                            fontWeight: 600 
                          }}
                        >
                          Retry
                        </button>
                      </div>
                    ) : allOffers.filter(o => Number(o.status) === 1).length === 0 ? (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <TagIcon style={{ 
                          width: "28px", 
                          height: "28px", 
                          color: theme.textMuted, 
                          marginBottom: "8px", 
                          opacity: 0.5 
                        }} />
                        <p style={{ fontSize: "12px", color: theme.textMuted }}>No active offers</p>
                      </div>
                    ) : (
                      allOffers.filter(o => Number(o.status) === 1).map((offer) => (
                        <div key={offer.id} style={{
                          background: theme.surfaceAlt,
                          borderRadius: "10px",
                          padding: "12px",
                          marginBottom: "8px",
                          border: `1px solid ${theme.border}`,
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          transition: "all 0.2s"
                        }}
                        onMouseEnter={(e) => { e.currentTarget.style.borderColor = theme.primary; }}
                        onMouseLeave={(e) => { e.currentTarget.style.borderColor = theme.border; }}>
                          <div>
                            <div style={{ fontSize: "12px", fontWeight: 600, color: theme.textPrimary }}>{offer.offer_name}</div>
                            <div style={{ fontSize: "10px", color: theme.textMuted }}>
                              {(offer.offer_type === 'flat' || offer.offer_type === 'discount') && `₹${offer.offer} OFF`}
                              {(offer.offer_type === 'percent' || offer.offer_type === 'percentage') && `${offer.offer}% OFF`}
                              {(offer.offer_type === 'bogo' || offer.offer_type === 'buy_get') && `Buy ${offer.buy_quantity || 1}, Get ${offer.free_quantity || 1} Free`}
                              {offer.offer_type === 'combo' && `Combo ₹${offer.offer}`}
                              {offer.offer_type === 'buy_get_x' && `${offer.buy_quantity}+Free`}
                            </div>
                          </div>
                          <div style={{ display: "flex", gap: "4px" }}>
                            <button onClick={() => handleEditOffer(offer)} style={{
                              padding: "2px 8px",
                              borderRadius: "4px",
                              border: "none",
                              background: theme.warningLight,
                              color: theme.warning,
                              cursor: "pointer",
                              fontSize: "9px",
                            }}>Edit</button>
                            <button onClick={() => handleDeleteOffer(offer.id)} style={{
                              padding: "2px 8px",
                              borderRadius: "4px",
                              border: "none",
                              background: theme.dangerLight,
                              color: theme.danger,
                              cursor: "pointer",
                              fontSize: "9px",
                            }}>Del</button>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </PermissionGuard>
            </div>
          </div>
        )}

        {/* ─── TIMINGS TAB ─── */}
        {activeTab === "timings" && (
          <PermissionGuard permission="restaurants.timings" fallback={
            <div style={{ 
              background: theme.surface, 
              borderRadius: "14px", 
              border: `1px solid ${theme.border}`, 
              padding: "40px", 
              textAlign: "center" 
            }}>
              <div style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.3 }}>🔒</div>
              <h3 style={{ fontSize: "16px", fontWeight: 600, color: theme.textPrimary, marginBottom: "8px" }}>Access Denied</h3>
              <p style={{ fontSize: "13px", color: theme.textMuted }}>You don't have permission to view timings</p>
            </div>
          }>
            <div style={{ 
              background: theme.surface, 
              borderRadius: "14px", 
              border: `1px solid ${theme.border}`, 
              padding: "40px", 
              textAlign: "center" 
            }}>
              <div style={{ display: "flex", justifyContent: "center", gap: "48px", flexWrap: "wrap", marginBottom: "24px" }}>
                <div>
                  <div style={{ fontSize: "11px", color: theme.textMuted, marginBottom: "4px" }}>Opening Time</div>
                  <div style={{ fontSize: "28px", fontWeight: 700, color: theme.textPrimary }}>{restaurant.shiftStart || "10:00 AM"}</div>
                </div>
                <div>
                  <div style={{ fontSize: "11px", color: theme.textMuted, marginBottom: "4px" }}>Closing Time</div>
                  <div style={{ fontSize: "28px", fontWeight: 700, color: theme.textPrimary }}>{restaurant.shiftEnd || "11:00 PM"}</div>
                </div>
              </div>
              <PermissionGuard permission="restaurants.timings" fallback={null}>
                <button 
                  onClick={handleViewSchedule} 
                  style={{ 
                    padding: "10px 24px", 
                    borderRadius: "10px", 
                    border: "none", 
                    background: theme.primary, 
                    color: "#fff", 
                    cursor: "pointer", 
                    display: "inline-flex", 
                    alignItems: "center", 
                    gap: "8px", 
                    fontSize: "13px", 
                    fontWeight: 600,
                    transition: "all 0.2s"
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <ClockIcon /> Edit Timings
                </button>
              </PermissionGuard>
            </div>
          </PermissionGuard>
        )}

        {/* ─── PAYMENTS TAB ─── */}
        {activeTab === "payments" && (
          <PermissionGuard permission="restaurants.payments" fallback={
            <div style={{ 
              background: theme.surface, 
              borderRadius: "14px", 
              border: `1px solid ${theme.border}`, 
              padding: "40px", 
              textAlign: "center" 
            }}>
              <div style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.3 }}>🔒</div>
              <h3 style={{ fontSize: "16px", fontWeight: 600, color: theme.textPrimary, marginBottom: "8px" }}>Access Denied</h3>
              <p style={{ fontSize: "13px", color: theme.textMuted }}>You don't have permission to view payments</p>
            </div>
          }>
            <div style={{ 
              background: theme.surface, 
              borderRadius: "14px", 
              border: `1px solid ${theme.border}`, 
              padding: "24px" 
            }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "16px" }}>
                <div style={{ 
                  textAlign: "center", 
                  padding: "20px", 
                  background: theme.surfaceAlt, 
                  borderRadius: "12px",
                  border: `1px solid ${theme.border}`
                }}>
                  <div style={{ fontSize: "26px", fontWeight: 700, color: "#3b82f6" }}>₹{paymentSummary.total.toLocaleString()}</div>
                  <div style={{ fontSize: "11px", color: theme.textMuted }}>Restaurant Earnings</div>
                </div>
                <div style={{ 
                  textAlign: "center", 
                  padding: "20px", 
                  background: theme.surfaceAlt, 
                  borderRadius: "12px",
                  border: `1px solid ${theme.border}`
                }}>
                  <div style={{ fontSize: "26px", fontWeight: 700, color: "#10b981" }}>₹{paymentSummary.completed.toLocaleString()}</div>
                  <div style={{ fontSize: "11px", color: theme.textMuted }}>Paid Settlements</div>
                </div>
                <div style={{ 
                  textAlign: "center", 
                  padding: "20px", 
                  background: theme.surfaceAlt, 
                  borderRadius: "12px",
                  border: `1px solid ${theme.border}`
                }}>
                  <div style={{ fontSize: "26px", fontWeight: 700, color: "#f59e0b" }}>₹{paymentSummary.pending.toLocaleString()}</div>
                  <div style={{ fontSize: "11px", color: theme.textMuted }}>Pending Settlement</div>
                </div>
                <div style={{ 
                  textAlign: "center", 
                  padding: "20px", 
                  background: theme.surfaceAlt, 
                  borderRadius: "12px",
                  border: `1px solid ${theme.border}`
                }}>
                  <div style={{ fontSize: "26px", fontWeight: 700, color: "#8b5cf6" }}>₹{paymentSummary.platformFee.toLocaleString()}</div>
                  <div style={{ fontSize: "11px", color: theme.textMuted }}>Platform Earnings</div>
                </div>
              </div>
              <div style={{ marginTop: "18px", display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: "12px" }}>
                <div style={{ padding: "14px", borderRadius: "10px", background: theme.surfaceAlt, border: `1px solid ${theme.border}` }}><b>₹{paymentSummary.available.toLocaleString()}</b><div style={{ fontSize: "11px", color: theme.textMuted }}>Available Balance</div></div>
                <div style={{ padding: "14px", borderRadius: "10px", background: theme.surfaceAlt, border: `1px solid ${theme.border}` }}><b>₹{paymentSummary.orderValue.toLocaleString()}</b><div style={{ fontSize: "11px", color: theme.textMuted }}>Delivered Order Value</div></div>
                <div style={{ padding: "14px", borderRadius: "10px", background: theme.surfaceAlt, border: `1px solid ${theme.border}` }}><b>{paymentSummary.deliveredOrders} / {paymentSummary.totalOrders}</b><div style={{ fontSize: "11px", color: theme.textMuted }}>Delivered / Total Orders</div></div>
              </div>
              <h3 style={{ margin: "24px 0 12px", fontSize: "15px", color: theme.textPrimary }}>Order-wise Earnings</h3>
              {paymentLoading ? <div style={{ padding: "24px", textAlign: "center", color: theme.textMuted }}>Loading earnings...</div> : paymentData.length === 0 ? <div style={{ padding: "24px", textAlign: "center", color: theme.textMuted }}>No order earnings found</div> : (
                <div style={{ overflowX: "auto", border: `1px solid ${theme.border}`, borderRadius: "10px" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "760px" }}>
                    <thead><tr style={{ background: theme.surfaceAlt }}>{["Order", "Date", "Customer", "Order Value", "Restaurant Earning", "Platform", "Payment", "Status"].map(h => <th key={h} style={{ padding: "11px", textAlign: "left", fontSize: "11px", color: theme.textMuted }}>{h}</th>)}</tr></thead>
                    <tbody>{paymentData.map(row => <tr key={row.id} style={{ borderTop: `1px solid ${theme.border}` }}>
                      <td style={{ padding: "11px", fontWeight: 700 }}>#{row.id}</td>
                      <td style={{ padding: "11px", fontSize: "12px" }}>{row.created_at ? new Date(row.created_at).toLocaleString("en-IN") : "N/A"}</td>
                      <td style={{ padding: "11px" }}>{row.receiver_name || "N/A"}</td>
                      <td style={{ padding: "11px" }}>₹{Number(row.final_amount || 0).toLocaleString()}</td>
                      <td style={{ padding: "11px", color: theme.success, fontWeight: 700 }}>₹{Number(row.business_amount || 0).toLocaleString()}</td>
                      <td style={{ padding: "11px" }}>₹{Number(row.platform_amount || 0).toLocaleString()}</td>
                      <td style={{ padding: "11px" }}>{row.pay_method || "N/A"} / {row.pay_status || "pending"}</td>
                      <td style={{ padding: "11px" }}>{row.order_status_user || row.order_status_restro || "pending"}</td>
                    </tr>)}</tbody>
                  </table>
                </div>
              )}
            </div>
          </PermissionGuard>
        )}

        {/* ─── REVIEWS TAB ─── */}
        {activeTab === "reviews" && (
          <PermissionGuard permission="restaurants.reviews" fallback={
            <div style={{ 
              background: theme.surface, 
              borderRadius: "14px", 
              border: `1px solid ${theme.border}`, 
              padding: "40px", 
              textAlign: "center" 
            }}>
              <div style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.3 }}>🔒</div>
              <h3 style={{ fontSize: "16px", fontWeight: 600, color: theme.textPrimary, marginBottom: "8px" }}>Access Denied</h3>
              <p style={{ fontSize: "13px", color: theme.textMuted }}>You don't have permission to view reviews</p>
            </div>
          }>
            <div style={{ 
              background: theme.surface, 
              borderRadius: "14px", 
              border: `1px solid ${theme.border}`, 
              padding: "48px", 
              textAlign: "center" 
            }}>
              <div style={{ fontSize: "56px", marginBottom: "12px" }}>⭐</div>
              <div style={{ fontSize: "40px", fontWeight: 700, color: theme.textPrimary, marginBottom: "4px" }}>{restaurant.rating || 0}</div>
              <div style={{ fontSize: "13px", color: theme.textMuted, marginBottom: "16px" }}>Average rating from {restaurant.totalRatings || 0} ratings</div>
              <div style={{ 
                display: "inline-flex", 
                alignItems: "center", 
                gap: "8px", 
                padding: "8px 20px", 
                background: theme.surfaceAlt, 
                borderRadius: "20px", 
                border: `1px solid ${theme.border}` 
              }}>
                <span style={{ fontSize: "12px", color: theme.textMuted }}>Total Reviews:</span>
                <span style={{ fontSize: "14px", fontWeight: 600, color: theme.textPrimary }}>{restaurant.totalReviews || 0}</span>
              </div>
            </div>
          </PermissionGuard>
        )}

        {/* ─── LOCATION TAB ─── */}
        {activeTab === "location" && (
          <PermissionGuard permission="restaurants.location" fallback={
            <div style={{ 
              background: theme.surface, 
              borderRadius: "14px", 
              border: `1px solid ${theme.border}`, 
              padding: "40px", 
              textAlign: "center" 
            }}>
              <div style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.3 }}>🔒</div>
              <h3 style={{ fontSize: "16px", fontWeight: 600, color: theme.textPrimary, marginBottom: "8px" }}>Access Denied</h3>
              <p style={{ fontSize: "13px", color: theme.textMuted }}>You don't have permission to view location</p>
            </div>
          }>
            <div style={{ 
              background: theme.surface, 
              borderRadius: "14px", 
              border: `1px solid ${theme.border}`, 
              padding: "40px", 
              textAlign: "center" 
            }}>
              <div style={{ fontSize: "48px", marginBottom: "16px" }}>📍</div>
              <h3 style={{ fontSize: "18px", fontWeight: 600, color: theme.textPrimary, marginBottom: "8px" }}>Restaurant Location</h3>
              <p style={{ fontSize: "13px", color: theme.textMuted, marginBottom: "16px" }}>
                {restaurant.address || "No address available"}
              </p>
              {restaurant.latitude && restaurant.longitude && (
                <div style={{ 
                  display: "inline-flex", 
                  alignItems: "center", 
                  gap: "12px", 
                  padding: "8px 16px", 
                  background: theme.surfaceAlt, 
                  borderRadius: "10px", 
                  border: `1px solid ${theme.border}`,
                  fontSize: "12px",
                  color: theme.textMuted
                }}>
                  <span>Lat: {restaurant.latitude}</span>
                  <span>|</span>
                  <span>Lng: {restaurant.longitude}</span>
                </div>
              )}
              <br />
              <PermissionGuard permission="restaurants.location" fallback={null}>
                <button 
                  onClick={handleLocationTabClick} 
                  style={{ 
                    marginTop: "20px", 
                    padding: "10px 24px", 
                    borderRadius: "10px", 
                    border: "none", 
                    background: theme.primary, 
                    color: "#fff", 
                    cursor: "pointer", 
                    display: "inline-flex", 
                    alignItems: "center", 
                    gap: "8px", 
                    fontSize: "13px", 
                    fontWeight: 600,
                    transition: "all 0.2s"
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = `0 4px 12px ${theme.primary}40`; }}
                  onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  <LocationIcon /> Update Location
                </button>
              </PermissionGuard>
            </div>
          </PermissionGuard>
        )}

        {/* ─── DOCUMENTS TAB ─── */}
        {activeTab === "documents" && (
          <PermissionGuard permission="restaurants.documents" fallback={
            <div style={{ 
              background: theme.surface, 
              borderRadius: "14px", 
              border: `1px solid ${theme.border}`, 
              padding: "40px", 
              textAlign: "center" 
            }}>
              <div style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.3 }}>🔒</div>
              <h3 style={{ fontSize: "16px", fontWeight: 600, color: theme.textPrimary, marginBottom: "8px" }}>Access Denied</h3>
              <p style={{ fontSize: "13px", color: theme.textMuted }}>You don't have permission to view documents</p>
            </div>
          }>
            <div style={{ 
              background: theme.surface, 
              borderRadius: "14px", 
              border: `1px solid ${theme.border}`, 
              padding: "24px" 
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
                <DocumentIcon style={{ color: theme.primary }} />
                <h3 style={{ fontSize: "16px", fontWeight: 600, color: theme.textPrimary, margin: 0 }}>All Documents & Certificates</h3>
              </div>
              {documents.length === 0 ? (
                <div style={{ textAlign: "center", padding: "40px", color: theme.textMuted }}>
                  <DocumentIcon style={{ width: "40px", height: "40px", marginBottom: "12px", opacity: 0.5 }} />
                  <p style={{ fontSize: "13px" }}>No documents uploaded yet</p>
                </div>
              ) : (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))", gap: "12px" }}>
                  {documents.map((doc, idx) => <DocumentCard key={idx} document={doc} theme={theme} />)}
                </div>
              )}
            </div>
          </PermissionGuard>
        )}

        {/* ─── OFFERS TAB ─── */}
        // ─────────────────────────────────────────────────────────────────────────────
// OFFERS TAB - WITH BULK DELETE & SELECT ALL
// ─────────────────────────────────────────────────────────────────────────────
{activeTab === "offers" && (
  <PermissionGuard permission="restaurants.active_offers" fallback={
    <div style={{ 
      background: theme.surface, 
      borderRadius: "14px", 
      border: `1px solid ${theme.border}`, 
      padding: "40px", 
      textAlign: "center" 
    }}>
      <div style={{ fontSize: "48px", marginBottom: "16px", opacity: 0.3 }}>🔒</div>
      <h3 style={{ fontSize: "16px", fontWeight: 600, color: theme.textPrimary, marginBottom: "8px" }}>Access Denied</h3>
      <p style={{ fontSize: "13px", color: theme.textMuted }}>You don't have permission to view offers</p>
    </div>
  }>
    <div style={{ 
      background: theme.surface, 
      borderRadius: "14px", 
      border: `1px solid ${theme.border}`, 
      overflow: "hidden" 
    }}>
      <div style={{
        padding: "16px 20px",
        borderBottom: `1px solid ${theme.border}`,
        background: theme.surfaceAlt,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "10px",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <TagIcon style={{ width: "18px", height: "18px", color: theme.primary }} />
          <div>
            <h3 style={{ fontSize: "15px", fontWeight: 600, color: theme.textPrimary, margin: 0 }}>All Offers</h3>
            <p style={{ fontSize: "11px", color: theme.textMuted, margin: 0 }}>{allOffers.length} total offer{allOffers.length !== 1 ? 's' : ''}</p>
          </div>
        </div>
        <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
          <input
            type="text"
            placeholder="Search offers..."
            value={offerSearch}
            onChange={(e) => { setOfferSearch(e.target.value); setCurrentPage(1); }}
            style={{
              padding: "6px 12px",
              borderRadius: "8px",
              border: `1px solid ${theme.border}`,
              background: theme.surface,
              color: theme.textPrimary,
              fontSize: "12px",
              outline: "none",
              width: "150px",
            }}
          />
          <PermissionGuard permission="restaurants.active_offers" fallback={null}>
            <button 
              onClick={handleGoToOffers} 
              style={{
                padding: "6px 16px",
                borderRadius: "8px",
                border: "none",
                background: theme.primary,
                color: "#fff",
                cursor: "pointer",
                fontSize: "12px",
                fontWeight: 600,
                display: "flex",
                alignItems: "center",
                gap: "6px",
              }}
            >
              <PlusIcon style={{ width: "14px", height: "14px" }} /> Create / Manage Offers
            </button>
          </PermissionGuard>
        </div>
      </div>
      
      <div style={{ padding: "16px" }}>
        {loadingOffers ? (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "40px" }}>
            <SpinnerIcon /> <span style={{ marginLeft: "10px", fontSize: "13px", color: theme.textMuted }}>Loading offers...</span>
          </div>
        ) : offerError ? (
          <div style={{ textAlign: "center", padding: "30px" }}>
            <p style={{ fontSize: "13px", color: theme.danger }}>{offerError}</p>
            <button onClick={fetchAllOffers} style={{ marginTop: "10px", padding: "6px 16px", borderRadius: "6px", border: "none", background: theme.primary, color: "#fff", cursor: "pointer", fontSize: "12px" }}>Retry</button>
          </div>
        ) : allOffers.length === 0 ? (
          <div style={{ textAlign: "center", padding: "40px" }}>
            <TagIcon style={{ width: "40px", height: "40px", color: theme.textMuted, marginBottom: "12px", opacity: 0.5 }} />
            <p style={{ fontSize: "14px", color: theme.textMuted }}>No offers created yet</p>
            <p style={{ fontSize: "12px", color: theme.textMuted }}>Create your first offer to attract more customers</p>
          </div>
        ) : (
          <>
            {/* Bulk Actions Bar */}
            <div style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "10px 14px",
              marginBottom: "12px",
              background: selectedOfferIds.length > 0 ? `${theme.primary}15` : theme.surfaceAlt,
              borderRadius: "10px",
              border: `1px solid ${selectedOfferIds.length > 0 ? theme.primary : theme.border}`,
              flexWrap: "wrap",
              transition: "all 0.3s ease",
            }}>
              <span style={{ fontSize: "12px", color: theme.textMuted, fontWeight: 500 }}>
                {selectedOfferIds.length} offer{selectedOfferIds.length !== 1 ? 's' : ''} selected
              </span>
              {selectedOfferIds.length > 0 && (
                <>
                  <button
                    onClick={handleBulkDeleteOffers}
                    disabled={bulkDeleting}
                    style={{
                      padding: "5px 14px",
                      borderRadius: "6px",
                      border: "none",
                      background: bulkDeleting ? theme.textMuted : theme.danger,
                      color: "#fff",
                      cursor: bulkDeleting ? "not-allowed" : "pointer",
                      fontSize: "11px",
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                      opacity: bulkDeleting ? 0.6 : 1,
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      if (!bulkDeleting) {
                        e.currentTarget.style.transform = "translateY(-1px)";
                        e.currentTarget.style.boxShadow = `0 4px 12px ${theme.danger}40`;
                      }
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    {bulkDeleting ? <SpinnerIcon /> : <TrashIcon />}
                    {bulkDeleting ? 'Deleting...' : `Delete Selected (${selectedOfferIds.length})`}
                  </button>
                  <button
                    onClick={() => setSelectedOfferIds([])}
                    style={{
                      padding: "5px 14px",
                      borderRadius: "6px",
                      border: `1px solid ${theme.border}`,
                      background: theme.surface,
                      color: theme.textSecondary,
                      cursor: "pointer",
                      fontSize: "11px",
                      fontWeight: 500,
                      transition: "all 0.2s",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background = theme.surfaceAlt;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background = theme.surface;
                    }}
                  >
                    Clear Selection
                  </button>
                </>
              )}
              <span style={{ marginLeft: "auto", fontSize: "11px", color: theme.textMuted }}>
                {filteredOffers.length} offer{filteredOffers.length !== 1 ? 's' : ''} showing
              </span>
            </div>

            <div className="offer-table-container">
              <table className="offer-table">
                <thead>
                  <tr style={{
                    borderBottom: `2px solid ${theme.border}`,
                    background: theme.surfaceAlt,
                  }}>
                    <th style={{ padding: "8px 10px", textAlign: "center", fontSize: "10px", fontWeight: 700, color: theme.primary, width: "36px" }}>
                      <input
                        type="checkbox"
                        checked={filteredOffers.length > 0 && selectedOfferIds.length === filteredOffers.map(o => String(o.id)).length}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedOfferIds(filteredOffers.map(o => String(o.id)));
                          } else {
                            setSelectedOfferIds([]);
                          }
                        }}
                        style={{
                          accentColor: theme.primary,
                          cursor: "pointer",
                          width: "14px",
                          height: "14px",
                        }}
                      />
                    </th>
                    <th style={{ padding: "8px 12px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: theme.primary, width: "30px" }}>#</th>
                    <th style={{ padding: "8px 12px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: theme.primary }}>Offer Name</th>
                    <th style={{ padding: "8px 12px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: theme.primary }}>Type</th>
                    <th style={{ padding: "8px 12px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: theme.primary }}>Discount</th>
                    <th style={{ padding: "8px 12px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: theme.primary }}>Start Date</th>
                    <th style={{ padding: "8px 12px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: theme.primary }}>End Date</th>
                    <th style={{ padding: "8px 12px", textAlign: "left", fontSize: "10px", fontWeight: 700, color: theme.primary }}>Status</th>
                    <th style={{ padding: "8px 12px", textAlign: "right", fontSize: "10px", fontWeight: 700, color: theme.primary }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedOffers.map((offer, idx) => {
                    const isChecked = selectedOfferIds.includes(String(offer.id));
                    return (
                      <tr key={offer.id} style={{
                        borderBottom: `1px solid ${theme.border}`,
                        transition: "background 0.2s",
                        opacity: Number(offer.status) !== 1 ? 0.6 : 1,
                        background: isChecked ? `${theme.primary}10` : "transparent",
                      }}
                      onMouseEnter={(e) => {
                        if (!isChecked) e.currentTarget.style.background = theme.surfaceAlt;
                      }}
                      onMouseLeave={(e) => {
                        if (!isChecked) e.currentTarget.style.background = "transparent";
                      }}>
                        <td style={{ padding: "6px 10px", textAlign: "center" }}>
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => {
                              setSelectedOfferIds(prev =>
                                prev.includes(String(offer.id))
                                  ? prev.filter(id => id !== String(offer.id))
                                  : [...prev, String(offer.id)]
                              );
                            }}
                            style={{
                              accentColor: theme.primary,
                              cursor: "pointer",
                              width: "14px",
                              height: "14px",
                            }}
                          />
                        </td>
                        <td style={{ padding: "6px 10px", fontSize: "11px", color: theme.textMuted, textAlign: "center" }}>
                          {startIndex + idx + 1}
                        </td>
                        <td style={{ padding: "6px 10px", fontSize: "12px", fontWeight: 500, color: theme.textPrimary }}>
                          {offer.offer_name || "Unnamed Offer"}
                        </td>
                        <td style={{ padding: "6px 10px" }}>
                          <span style={{
                            padding: "2px 8px",
                            borderRadius: "12px",
                            fontSize: "9px",
                            fontWeight: 600,
                            background: `${getOfferColor(offer.offer_type)}15`,
                            color: getOfferColor(offer.offer_type),
                          }}>
                            {offer.offer_type || "Unknown"}
                          </span>
                        </td>
                        <td style={{ padding: "6px 10px", fontSize: "13px", fontWeight: 700, color: getOfferColor(offer.offer_type) }}>
                          {getOfferDescription(offer)}
                        </td>
                        <td style={{ padding: "6px 10px", fontSize: "10px", color: theme.textMuted }}>
                          {formatDate(offer.offer_start)}
                        </td>
                        <td style={{ padding: "6px 10px", fontSize: "10px", color: theme.textMuted }}>
                          {formatDate(offer.offer_end)}
                        </td>
                        <td style={{ padding: "6px 10px" }}>
                          <span style={{
                            padding: "2px 8px",
                            borderRadius: "12px",
                            fontSize: "9px",
                            fontWeight: 600,
                            background: Number(offer.status) === 1 ? theme.successLight : `${theme.textMuted}1a`,
                            color: Number(offer.status) === 1 ? theme.success : theme.textMuted,
                          }}>
                            {Number(offer.status) === 1 ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td style={{ padding: "6px 10px", textAlign: "right" }}>
                          <div style={{ display: "flex", gap: "4px", justifyContent: "flex-end" }}>
                            <button
                              onClick={() => handleEditOffer(offer)}
                              style={{
                                padding: "2px 8px",
                                borderRadius: "4px",
                                border: "none",
                                background: theme.warningLight,
                                color: theme.warning,
                                cursor: "pointer",
                                fontSize: "9px",
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                              }}
                            >
                              <EditIcon style={{ width: "10px", height: "10px" }} /> Edit
                            </button>
                            <button
                              onClick={() => handleDeleteOffer(offer.id)}
                              style={{
                                padding: "2px 8px",
                                borderRadius: "4px",
                                border: "none",
                                background: theme.dangerLight,
                                color: theme.danger,
                                cursor: "pointer",
                                fontSize: "9px",
                                display: "flex",
                                alignItems: "center",
                                gap: "2px",
                              }}
                            >
                              <TrashIcon style={{ width: "10px", height: "10px" }} /> Del
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination Controls */}
            {filteredOffers.length > rowsPerPage && (
              <div style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 0 0 0",
                borderTop: `1px solid ${theme.border}`,
                marginTop: "16px",
                flexWrap: "wrap",
                gap: "10px",
              }}>
                <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "12px", color: theme.textMuted }}>
                  <span>Rows:</span>
                  <select
                    value={rowsPerPage}
                    onChange={(e) => { setRowsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                    style={{
                      padding: "4px 10px",
                      borderRadius: "6px",
                      border: `1px solid ${theme.border}`,
                      background: theme.surface,
                      color: theme.textPrimary,
                      fontSize: "11px",
                      cursor: "pointer",
                      outline: "none",
                    }}
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  <span>
                    {startIndex + 1} - {Math.min(startIndex + rowsPerPage, filteredOffers.length)} of {filteredOffers.length}
                  </span>
                </div>
                <div style={{ display: "flex", gap: "6px" }}>
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    disabled={currentPage === 1}
                    style={{
                      padding: "6px 14px",
                      borderRadius: "6px",
                      border: `1px solid ${theme.border}`,
                      background: theme.surface,
                      color: currentPage === 1 ? theme.textMuted : theme.textSecondary,
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      fontSize: "11px",
                      opacity: currentPage === 1 ? 0.5 : 1,
                    }}
                  >
                    Previous
                  </button>
                  <span style={{
                    padding: "6px 14px",
                    borderRadius: "6px",
                    background: theme.primary,
                    color: "#fff",
                    fontSize: "11px",
                    fontWeight: 600,
                  }}>
                    {currentPage} / {totalPages}
                  </span>
                  <button
                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: "6px 14px",
                      borderRadius: "6px",
                      border: `1px solid ${theme.border}`,
                      background: theme.surface,
                      color: currentPage === totalPages ? theme.textMuted : theme.textSecondary,
                      cursor: currentPage === totalPages ? "not-allowed" : "pointer",
                      fontSize: "11px",
                      opacity: currentPage === totalPages ? 0.5 : 1,
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  </PermissionGuard>
)}
      </div>
    </div>
  );
};

export default RestaurantDetailPage;
